module.exports = "/fonts/vendor/line-awesome/dist/line-awesome/la-solid-900.woff2?36fc297902c9a2e857858baa6ac25f2c";